var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rows.length)?_c('div',{staticClass:"stock-line-lot-availability caption grey--text mt-1"},_vm._l((_vm.rows),function(row,index){return _c('div',{key:`lot-avail-${index}`,staticClass:"stock-line-lot-availability__row"},[_vm._v(" "+_vm._s(row)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }